import { RequestMethod } from "@/shared/utils/RequestMethod";
import { api } from "../app.api";

export const deviceApi = api
  .enhanceEndpoints({ addTagTypes: ["scale"] })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      getScale: builder.query({
        query: ({ branchId }) => ({
          url: `/branchs/${branchId}/scales?branchId=${branchId}`,
          method: RequestMethod.GET,
        }),
      }),
      updateScale: builder.mutation({
        query: ({ id, name, secret_key, branch_id }) => ({
          url: `/branchs/${branch_id}/scales/${id}`,
          method: RequestMethod.PUT,
          body: { name, secret_key, branch_id },
        }),
      }),
      deleteScale: builder.mutation({
        query: ({ id, branch_id }) => ({
          url: `/branchs/${branch_id}/scales/${id}`,
          method: RequestMethod.DELETE,
        }),
      }),
      getScaleById: builder.query({
        query: ({ id, branch_id }) => ({
          url: `/branchs/${branch_id}/scales/$/${id}`,
          method: RequestMethod.GET,
        }),
      }),
      createScale: builder.mutation({
        query: ({ body, branchId }) => ({
          url: `/branchs/${branchId}/scales`,
          method: RequestMethod.POST,
          body,
        }),
      }),
    }),
  });

export const {
  useGetScaleQuery,
  useUpdateScaleMutation,
  useDeleteScaleMutation,
  useGetScaleByIdQuery,
  useCreateScaleMutation,
} = deviceApi;
